import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { MainComponent } from './shared/main/main.component';
import { IndexComponent } from './index/index.component';
import { ManagePostsComponent } from './manage-posts/manage-posts.component';
import { RewardsComponent } from './rewards/rewards.component';
import { SubsetComponent } from './subset/subset.component';
import { FinancialComponent } from './financial/financial.component';
import { ReportsComponent } from './reports/reports.component';
// import { ContractComponent } from './contract/contract.component';


const routes: Routes = [
  {
    path: 'login',
    canActivate: [AuthGuard],
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: MainComponent,
    children: [
      {
        path: '',
        pathMatch: 'full',
        data: { title: 'داشبورد' },
        canActivate: [AuthGuard],
        component: IndexComponent,
      },
      {
        path: 'profile',
        data: { title: 'پروفایل' },
        loadChildren: () => import('./profile/profile.module').then(m => m.ProfileModule),
      },
      {
        path: 'contract',
        loadChildren: () => import('./contract/contract.module').then(m => m.ContractModule)
      },
      {
        path: 'reward',
        data: { title: 'پورسانت و پاداش' },
        component: RewardsComponent,
      },
      {
        path: 'subset',
        data: { title: 'زیر مجموعه‌ها' },
        component: SubsetComponent,
      },
      {
        path: 'financial',
        data: { title: 'امور مالی' },
        component: FinancialComponent,
      },
      {
        path: 'support',
        data: { title: 'پشتیبانی' },
        loadChildren: () => import('./support/support.module').then(m => m.SupportModule),
      },
      {
        path: 'report',
        data: { title: 'ریپورت' },
        component: ReportsComponent,
      },
      {
        path: 'manage-posts',
        loadChildren: () => import('./manage-posts/manage-posts.module').then(m => m.ManagePostsModule)
      },

      {
        path: 'users',
        loadChildren: () => import('./users/users.module').then(m => m.UsersModule)
      },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
